module.exports = __webpack_public_path__ + "img/icon_link.96e4b4ce.svg";